import { assertNotImplemented, release } from '@awayfl/swf-loader';
export function axCompare(a, b, options, sortOrder, compareFunction) {
    release || assertNotImplemented(!(options & 4 /* UNIQUESORT */), 'UNIQUESORT');
    release || assertNotImplemented(!(options & 8 /* RETURNINDEXEDARRAY */), 'RETURNINDEXEDARRAY');
    var result = 0;
    if (options & 1 /* CASEINSENSITIVE */) {
        a = String(a).toLowerCase();
        b = String(b).toLowerCase();
    }
    if (options & 16 /* NUMERIC */) {
        a = +a;
        b = +b;
        result = a < b ? -1 : (a > b ? 1 : 0);
    }
    else {
        result = compareFunction(a, b);
    }
    return result * sortOrder;
}
